// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-exercise-protection {
  position: relative;
  isolation: isolate;
}

.student-exercise-protection * {
  -webkit-user-select: text;
  user-select: text;
}

@media print {
  .student-exercise-protection {
    display: block !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/StudentExerciseProtection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".student-exercise-protection {\r\n  position: relative;\r\n  isolation: isolate;\r\n}\r\n\r\n.student-exercise-protection * {\r\n  -webkit-user-select: text;\r\n  user-select: text;\r\n}\r\n\r\n@media print {\r\n  .student-exercise-protection {\r\n    display: block !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
